import { gql } from '@apollo/client';

export const FETCH_LOCATIONS = gql`
  query GetLocations {
    findAllLocations {
      capacity
      capacityUnit
      city
      country
      employeeCount
      locationAddress
      locationName
      locationType
      rebuildCost
      rebuildTime
      state
      street
      uuid
      zipCode
      annualRevenueSupported
      processAreasCount
      processesCount
      processAreasMitigationAverage
    }
  }
`;

export const CREATE_LOCATION = gql`
  mutation location($data: CreateLocationInput!) {
    createLocation(data: $data) {
      capacity
      capacityUnit
      city
      country
      employeeCount
      locationAddress
      locationName
      locationType
      rebuildCost
      rebuildTime
      state
      street
      mtoMonth
      mtoRevenue
      rtoMonth
      rtoRevenue
      uuid
      zipCode
    }
  }
`;

export const EDIT_LOCATION = gql`
  mutation location($data: UpdateLocationInput!) {
    updateLocation(data: $data) {
      capacity
      capacityUnit
      city
      country
      employeeCount
      locationAddress
      locationName
      locationType
      rebuildCost
      rebuildTime
      state
      street
      mtoMonth
      mtoRevenue
      rtoMonth
      rtoRevenue
      uuid
      zipCode
    }
  }
`;

export const UPDATE_MTO_RTO = gql`
  mutation UpdateRtoMto($data: UpdateRtoMtoInput!) {
    updateRtoMto(data: $data) {
      mtoMonth
      mtoRevenue
      rtoMonth
      rtoRevenue
    }
  }
`;

export const DELETE_LOCATION = gql`
  mutation locationRemove($uuid: ID!) {
    deleteLocation(uuid: $uuid) {
      capacity
      capacityUnit
      city
      country
      employeeCount
      locationAddress
      locationName
      locationType
      rebuildCost
      rebuildTime
      state
      street
      uuid
      zipCode
    }
  }
`;

export const FETCH_LOCATION_BY_ID = gql`
  query GetLocation($uuid: ID!) {
    findLocationByUuid(uuid: $uuid) {
      planUUID
      bcpStatus
      lastBcpUpdate
      capacity
      capacityUnit
      city
      country
      employeeCount
      locationAddress
      lastManuallyUpdatedAt
      locationName
      locationType
      rebuildCost
      rebuildTime
      state
      street
      mtoMonth
      mtoRevenue
      rtoMonth
      rtoRevenue
      uuid
      zipCode
    }
  }
`;

export const FETCH_LOCATION_METADATA_BY_ID = gql`
  query GetLocationMetaData($uuid: ID!) {
    findLocationByUuid(uuid: $uuid) {
      planUUID
      locationName
      lastBcpUpdate
    }
  }
`;

export const EDIT_LOCATION_COMMENT = gql`
  mutation location($data: UpdateLocationCommentInput!) {
    updateLocationComment(data: $data) {
      capacity
      capacityUnit
      city
      comment
      country
      employeeCount
      locationAddress
      locationName
      locationType
      rebuildCost
      rebuildTime
      state
      street
      mtoMonth
      mtoRevenue
      rtoMonth
      rtoRevenue
      uuid
      zipCode
    }
  }
`;

export const REFRESH_LOCATIONS = gql`
  query RefreshLocations {
    rollUpProcessesAndProcessAreaMitigationPercentages
  }
`;
